import {RouteRecordRaw} from "vue-router";
import LogsYearlyPage from "@/modules/finances/pages/LogsYearlyPage.vue";
import LogsMonthlyPage from "@/modules/finances/pages/LogsMonthlyPage.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: '/bank',
    name: 'bank.index',
    component: LogsYearlyPage,
  },
  {
    path: '/bank/monthly',
    name: 'bank.monthly',
    component: LogsMonthlyPage,
  },
];